module.exports = "/fonts/FiraSans-SemiBoldItalic.ttf";